import {
  USER_DEVICE_FINGERPRINT_HASH_SET,
  USER_DEVICE_FINGERPRINT_HASH_GET
} from "app/redux/constants/actionTypes";

function deviceFingerprint(value) {
  if (value) {
    return {
      type: USER_DEVICE_FINGERPRINT_HASH_SET,
      value
    };
  } else {
    return {
      type: USER_DEVICE_FINGERPRINT_HASH_GET
    };
  }
}

const user = {
  deviceFingerprint
};

export default user;
export { deviceFingerprint };
